module.exports = __webpack_public_path__ + "img/planFamiliarColorMobile.ede97c8b.svg";